import React from 'react'
import "./sectionPartnerships.scss"

//Imagens:
import ImgSectionPartnerships from "../../../assets/partnerships/sectionPartnerships.png"
import { useTranslation } from 'react-i18next'

function SectionPartnerships() {
  const { t } = useTranslation()

  return (
    <div className='container-section-partnerships'>
      <div className='img-section-partnerships'>
        <img src={ImgSectionPartnerships} alt="" />
      </div>
      <div className='texts-section-partnerships'>
        <h1>{t("partners.title")}</h1>
        <p>{t("partners.section_text")}</p>
      </div>

    </div>
  )
}

export default SectionPartnerships